import {
  RequestGetListPair,
  RequestPair,
  RequestPairSetting,
  RequestUserPairSetting,
} from '../models/request/requestVoicePlus';
import {
  ResponsePairUser,
  ResponseUserPairWantJoined,
} from '../models/response/responseVoicePlus';
import { baseApi } from './baseApi';

const voicePlusAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // get list pair guest
    getListPair: builder.mutation<
      ResponseUserPairWantJoined[],
      RequestGetListPair
    >({
      query: (params: RequestGetListPair) => ({
        url: `/v0/pairs/radios/${params.id}`,
        method: 'GET',
      }),
    }),
    //FOR HOST
    // Pair setting
    settingPair: builder.mutation<ResponsePairUser, RequestPairSetting>({
      query: (params: RequestPairSetting) => ({
        url: `/v0/radios/${params.id}/pair-types/${params.type}`,
        method: 'PUT',
      }),
    }),
    // Choice Pair
    choicePair: builder.mutation<ResponsePairUser, RequestUserPairSetting>({
      query: (params: RequestUserPairSetting) => ({
        url: `/v0/radios/${params.id}/users/${params.userId}`,
        method: 'PUT',
      }),
    }),
    // remove Pair
    removePair: builder.mutation<ResponsePairUser, RequestUserPairSetting>({
      query: (params: RequestUserPairSetting) => ({
        url: `/v0/radios/${params.id}/users/${params.userId}`,
        method: 'DELETE',
      }),
    }),

    // FOR Audience
    // send pair request
    sendRequestPair: builder.mutation<ResponseUserPairWantJoined, RequestPair>({
      query: (data: RequestPair) => ({
        url: `/v0/pairs`,
        method: 'POST',
        body: data,
      }),
    }),
    // cancel pair request
    cancelRequestPair: builder.mutation<ResponseUserPairWantJoined, string>({
      query: (id: string) => ({
        url: `/v0/pairs/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});
export const {
  useGetListPairMutation,
  useSettingPairMutation,
  useChoicePairMutation,
  useRemovePairMutation,
  useSendRequestPairMutation,
  useCancelRequestPairMutation,
} = voicePlusAPI;
